import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://deutschbridge-lms-production.up.railway.app/api',
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('goethe_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('goethe_token');
      localStorage.removeItem('goethe_user');
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login';
      }
    }
    const message =
      err.response?.data?.error ||
      err.response?.data?.message ||
      err.message ||
      'An unexpected error occurred';
    const error = new Error(message);
    error.status = err.response?.status;
    error.data   = err.response?.data;
    return Promise.reject(error);
  }
);

export default API;